
class GuestInputModalController {
    constructor(guestModalService, addGuestService, moneyService) {
        this.guestModalService = guestModalService;
        this.addGuestService = addGuestService;
        this.moneyService = moneyService;
    }

    displayTotal () {
        const price = this.guestModalService.getConfig('time').price;
        const guestCount = this.addGuestService.getGuests().length;
        return this.moneyService.reduce(price * guestCount, true);
    }

    capitalizeType () {
        if (this.type) {
            return this.type;
        }

        const type = this.guestModalService.getConfig('event').type;
        if (type) {
            const words = type.split(' ');
            for (const index in words) {
                let word = words[index];
                words[index] = `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
            }
            this.type = words.join(' ').trim();
            return this.type;
        }
    }

    displayName () {
        return this.guestModalService.getConfig('event').name;
    }
}

GuestInputModalController.$inject = ['guestModalService', 'addGuestService', 'moneyService'];

export default GuestInputModalController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/guest.input.modal.controller.js